export const calculeSalePrice = (discount: number, originalPrice: number) => {
  const perc = discount / 100
  let salePriceVl = 0
  if (originalPrice !== 0 && discount > 0) {
    salePriceVl = (1 - perc) * originalPrice
  }

  if (discount > 100) return 0

  if (!discount || discount === 0) return originalPrice

  return salePriceVl
}
